/* global Shopify */
'use strict';

/* ============================================================
   ABLE PDP Customizer — Charm Bracelet + Leather Embossing
   ============================================================ */

/* ── Utilities ──────────────────────────────────────────── */

function generateUUID() {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
    var r = Math.random() * 16 | 0;
    var v = c === 'x' ? r : (r & 0x3 | 0x8);
    return v.toString(16);
  });
}

// Short human-readable bundle code for shipping team (excludes ambiguous chars 0/O/1/I/L)
function generateBundleCode() {
  var chars = 'ABCDEFGHJKLMNPQRSTUVWXYZ23456789';
  var result = '';
  for (var i = 0; i < 6; i++) {
    result += chars[Math.floor(Math.random() * chars.length)];
  }
  return result;
}

var INVALID_CHAR_HINT_MS = 2000;

function moneyFormat(cents) {
  if (Shopify && Shopify.formatMoney) {
    return Shopify.formatMoney(cents, Shopify.money_format);
  }
  return '$' + (cents / 100).toFixed(0);
}


/* ── Shared char-select utilities ───────────────────────── */

// Parses symbol_set JSON into normalized option objects.
// Each item can be:
//   "A-Z"                              → expand to all chars in that range
//   "♥"                                → single character, no image
//   {"img":"...","label":"Heart"}      → icon option — value is optional
//   {"value":"A","label":"Alpha"}      → char with label override
// cartValue is what goes into the line item property:
//   plain chars → the character itself ("A")
//   named icons → bracketed label ("[Heart]") so shippers see a clear name
// Default when nothing is configured: A–Z uppercase.
function parseCharOptions(raw) {
  var items = [];
  try {
    var parsed = JSON.parse(raw);
    if (Array.isArray(parsed)) items = parsed;
  } catch (e) {}

  var result = [];
  items.forEach(function(item) {
    if (typeof item === 'string') {
      var rangeMatch = item.trim().match(/^(.)([-–])(.)\s*$/);
      if (rangeMatch) {
        var start = rangeMatch[1].charCodeAt(0);
        var end = rangeMatch[3].charCodeAt(0);
        if (start <= end) {
          for (var c = start; c <= end; c++) {
            var ch = String.fromCharCode(c);
            result.push({ value: ch, cartValue: ch, img: null, label: null });
          }
        }
      } else if (item.trim().length > 0) {
        var ch = item.trim();
        result.push({ value: ch, cartValue: ch, img: null, label: null });
      }
    } else if (item && typeof item === 'object' && (item.value || item.label || item.img)) {
      var label = item.label || null;
      var value = item.value || null;
      var cartValue = label ? '[' + label + ']' : value;
      result.push({ value: value, cartValue: cartValue, img: item.img || null, label: label });
    }
  });

  if (result.length === 0) {
    for (var c = 65; c <= 90; c++) {
      var ch = String.fromCharCode(c);
      result.push({ value: ch, cartValue: ch, img: null, label: null });
    }
  }

  return result;
}

// Builds a compact character-guide element from a raw symbolSet value.
// Accepts the raw JSON string (charm) or array (leather).
// Returns a div.customizer__char-guide element, or null if nothing to show.
function buildCharGuide(rawSymbolSet) {
  var items;
  try {
    if (Array.isArray(rawSymbolSet)) {
      items = rawSymbolSet;
    } else {
      items = JSON.parse(rawSymbolSet || '[]');
    }
    if (!Array.isArray(items)) items = [];
  } catch (e) {
    return null;
  }
  if (!items.length) return null;

  var wrap = document.createElement('div');
  wrap.className = 'customizer__char-guide';

  items.forEach(function(item) {
    var pill = document.createElement('span');
    if (typeof item === 'string') {
      var m = item.match(/^(.)[-–](.)$/);
      if (m) {
        pill.className = 'customizer__char-guide-pill customizer__char-guide-pill--range';
        pill.textContent = m[1] + '–' + m[2];
      } else if (item.trim().length > 0) {
        pill.className = 'customizer__char-guide-pill';
        pill.textContent = item.trim();
      } else {
        return;
      }
    } else if (item && typeof item === 'object') {
      pill.className = 'customizer__char-guide-pill';
      if (item.img) {
        var img = document.createElement('img');
        img.src = item.img;
        img.alt = item.label || '';
        img.className = 'customizer__char-guide-pill-img';
        pill.appendChild(img);
        if (item.label) {
          pill.appendChild(document.createTextNode(' ' + item.label));
        }
      } else {
        var text = item.value || '';
        if (item.label && item.label !== item.value) {
          text += (text ? ' ' : '') + item.label;
        }
        if (!text) return;
        pill.textContent = text;
      }
    } else {
      return;
    }
    wrap.appendChild(pill);
  });

  if (!wrap.children.length) return null;
  return wrap;
}

// Builds a single-line text input, hint paragraph, and optional char guide element.
// options: { maxLength, charOptions, rawSymbolSet, hintText, onInput(value) }
// Returns { input, hint, guide } — caller is responsible for appending to the DOM.
function buildSingleLineInputEl(options) {
  var input = document.createElement('input');
  input.type = 'text';
  input.className = 'customizer__single-line-input';
  input.setAttribute('maxlength', String(options.maxLength));
  input.setAttribute('autocomplete', 'off');
  input.setAttribute('autocorrect', 'off');
  input.setAttribute('autocapitalize', 'off');
  input.setAttribute('spellcheck', 'false');

  var hint = document.createElement('p');
  hint.className = 'customizer__invalid-char-hint';
  hint.setAttribute('hidden', '');
  hint.textContent = options.hintText;
  var _hintTimer = null;

  var allowed = new Set(options.charOptions.map(function(o) { return o.value; }));

  input.addEventListener('input', function() {
    var raw = input.value;
    var filtered = Array.from(raw).filter(function(c) { return allowed.has(c); }).join('');
    if (filtered !== raw) {
      var pos = Math.max(0, (input.selectionStart || 0) - (raw.length - filtered.length));
      input.value = filtered;
      input.setSelectionRange(pos, pos);
      hint.removeAttribute('hidden');
      clearTimeout(_hintTimer);
      _hintTimer = setTimeout(function() { hint.setAttribute('hidden', ''); }, INVALID_CHAR_HINT_MS);
    }
    options.onInput(input.value);
  });

  var guide = buildCharGuide(options.rawSymbolSet);
  return { input: input, hint: hint, guide: guide };
}

// Builds one custom dropdown wrapper element (portaled to <body>).
// onSelectFn(opt, wrap, trigger) is called when an option is chosen.
// closeAllFn() is called to close peer dropdowns before opening this one.
function buildCharSelectEl(charOptions, charIndex, onSelectFn, closeAllFn) {
  var wrap = document.createElement('div');
  wrap.className = 'charm-char-select';
  wrap.dataset.charIndex = charIndex;

  var trigger = document.createElement('button');
  trigger.type = 'button';
  trigger.className = 'charm-char-select__trigger';
  trigger.setAttribute('aria-haspopup', 'listbox');
  trigger.setAttribute('aria-expanded', 'false');
  var placeholder = document.createElement('span');
  placeholder.className = 'charm-char-select__placeholder';
  placeholder.textContent = '+';
  trigger.appendChild(placeholder);

  var dropdown = null;

  var ensureDropdown = function() {
    if (dropdown) return dropdown;
    dropdown = document.createElement('div');
    dropdown.className = 'charm-char-select__dropdown';
    dropdown.setAttribute('role', 'listbox');
    dropdown.setAttribute('hidden', '');

    charOptions.forEach(function(opt) {
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.setAttribute('role', 'option');
      btn.dataset.cartValue = opt.cartValue;

      if (opt.img) {
        btn.className = 'charm-char-select__option charm-char-select__option--image';
        var img = document.createElement('img');
        img.className = 'charm-char-select__option-img';
        img.src = opt.img;
        img.alt = opt.label || '';
        img.width = 56;
        img.height = 56;
        btn.appendChild(img);
        if (opt.label) {
          var labelSpan = document.createElement('span');
          labelSpan.className = 'charm-char-select__option-label charm-char-select__option-label--primary';
          labelSpan.textContent = opt.label;
          btn.appendChild(labelSpan);
        }
      } else {
        btn.className = 'charm-char-select__option';
        var valSpan = document.createElement('span');
        valSpan.className = 'charm-char-select__option-value';
        valSpan.textContent = opt.value;
        btn.appendChild(valSpan);
        if (opt.label) {
          var labelSpan = document.createElement('span');
          labelSpan.className = 'charm-char-select__option-label';
          labelSpan.textContent = opt.label;
          btn.appendChild(labelSpan);
        }
      }

      btn.addEventListener('click', function(e) {
        e.stopPropagation();
        onSelectFn(opt, wrap, trigger);
      });

      dropdown.appendChild(btn);
    });

    document.body.appendChild(dropdown);
    return dropdown;
  };

  var scrollCloseHandler = null;

  var openDropdown = function() {
    var dd = ensureDropdown();
    var rect = trigger.getBoundingClientRect();
    dd.style.top = rect.bottom + 'px';
    dd.style.left = rect.left + 'px';
    dd.style.minWidth = Math.max(rect.width, 220) + 'px';
    dd.removeAttribute('hidden');
    trigger.setAttribute('aria-expanded', 'true');
    wrap.classList.add('charm-char-select--open');
    scrollCloseHandler = function(e) {
      if (dropdown && dropdown.contains(e.target)) return;
      wrap._closeDropdown();
    };
    window.addEventListener('scroll', scrollCloseHandler, { passive: true, capture: true });
  };

  wrap._closeDropdown = function() {
    if (dropdown) dropdown.setAttribute('hidden', '');
    trigger.setAttribute('aria-expanded', 'false');
    wrap.classList.remove('charm-char-select--open');
    if (scrollCloseHandler) {
      window.removeEventListener('scroll', scrollCloseHandler, { capture: true });
      scrollCloseHandler = null;
    }
  };
  wrap._removeDropdown = function() {
    if (dropdown && dropdown.parentNode) dropdown.parentNode.removeChild(dropdown);
  };

  trigger.addEventListener('click', function(e) {
    e.stopPropagation();
    var isOpen = wrap.classList.contains('charm-char-select--open');
    closeAllFn();
    if (!isOpen) openDropdown();
  });

  wrap.appendChild(trigger);
  return wrap;
}

// Updates a trigger button to reflect the chosen option.
function applySelectionToTrigger(opt, trigger) {
  trigger.innerHTML = '';
  if (opt.img) {
    var img = document.createElement('img');
    img.className = 'charm-char-select__trigger-img';
    img.src = opt.img;
    img.alt = opt.label || '';
    trigger.appendChild(img);
    if (opt.label) {
      var lbl = document.createElement('span');
      lbl.className = 'charm-char-select__trigger-label';
      lbl.textContent = opt.label;
      trigger.appendChild(lbl);
    }
  } else {
    var val = document.createElement('span');
    val.className = 'charm-char-select__trigger-value';
    val.textContent = opt.value;
    trigger.appendChild(val);
  }
}

// Marks the matching option as selected inside a dropdown element.
function markDropdownSelection(dropdown, cartValue) {
  if (!dropdown) return;
  dropdown.querySelectorAll('.charm-char-select__option').forEach(function(b) {
    var isSelected = b.dataset.cartValue === cartValue;
    b.classList.toggle('charm-char-select__option--selected', isSelected);
    b.setAttribute('aria-selected', isSelected ? 'true' : 'false');
  });
}

// Closes all open char-select dropdowns inside containerEl (or document if omitted).
function closeAllCharSelectsIn(containerEl) {
  (containerEl || document).querySelectorAll('.charm-char-select').forEach(function(sel) {
    if (sel._closeDropdown) sel._closeDropdown();
  });
}


/* ── Shopify rich text JSON → HTML ─────────────────────── */

function richTextToHtml(node) {
  if (!node) return '';
  if (typeof node === 'string') {
    try { node = JSON.parse(node); } catch (e) { return node; }
  }
  function renderNode(n) {
    if (!n) return '';
    var children = (n.children || []).map(renderNode).join('');
    switch (n.type) {
      case 'root': return children;
      case 'paragraph': return '<p>' + children + '</p>';
      case 'heading': return '<h' + (n.level || 2) + '>' + children + '</h' + (n.level || 2) + '>';
      case 'list': return (n.listType === 'ordered' ? '<ol>' : '<ul>') + children + (n.listType === 'ordered' ? '</ol>' : '</ul>');
      case 'list-item': return '<li>' + children + '</li>';
      case 'link': return '<a href="' + (n.url || '#') + '"' + (n.target ? ' target="' + n.target + '"' : '') + '>' + children + '</a>';
      case 'image': return '<img src="' + (n.url || '') + '" alt="' + (n.alt || '') + '" style="max-width:100%">';
      case 'text': {
        var t = (n.value || '').replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/\n/g, '<br>');
        if (n.bold) t = '<strong>' + t + '</strong>';
        if (n.italic) t = '<em>' + t + '</em>';
        if (n.underline) t = '<u>' + t + '</u>';
        if (n.strikethrough) t = '<s>' + t + '</s>';
        if (n.code) t = '<code>' + t + '</code>';
        return t;
      }
      default: return children;
    }
  }
  return renderNode(node);
}

/* ── Shared examples modal ──────────────────────────────── */

function openImagesModal(images, title, content) {
  var contentHtml = '';
  if (content) {
    try { contentHtml = richTextToHtml(JSON.parse(content)); } catch (e) { contentHtml = content; }
  }
  var hasImages = images && images.length > 0;
  if (!hasImages && !contentHtml) return;

  var modal = document.createElement('div');
  modal.className = 'charm-examples-modal';
  modal.setAttribute('role', 'dialog');
  modal.setAttribute('aria-modal', 'true');
  modal.setAttribute('aria-label', title || 'Examples');

  var thumbsHtml = hasImages ? images.map(function(url, i) {
    return '<button class="charm-examples-modal__thumb' + (i === 0 ? ' charm-examples-modal__thumb--active' : '') + '" type="button" data-img="' + url + '">' +
      '<img src="' + url + '" alt="Example ' + (i + 1) + '" loading="lazy">' +
      '</button>';
  }).join('') : '';

  modal.innerHTML = [
    '<div class="charm-examples-modal__backdrop"></div>',
    '<div class="charm-examples-modal__inner">',
      '<button class="charm-examples-modal__close" type="button" aria-label="Close">&#215;</button>',
      '<div class="charm-examples-modal__body">',
        hasImages ? '<img class="charm-examples-modal__main-img" src="' + images[0] + '" alt="Example">' : '',
        hasImages && images.length > 1 ? '<div class="charm-examples-modal__thumbs">' + thumbsHtml + '</div>' : '',
        contentHtml ? '<div class="charm-examples-modal__content">' + contentHtml + '</div>' : '',
      '</div>',
    '</div>'
  ].join('');

  document.body.appendChild(modal);

  var mainImg = modal.querySelector('.charm-examples-modal__main-img');
  var closeBtn = modal.querySelector('.charm-examples-modal__close');
  var backdrop = modal.querySelector('.charm-examples-modal__backdrop');

  modal.querySelectorAll('.charm-examples-modal__thumb').forEach(function(thumb) {
    thumb.addEventListener('click', function() {
      mainImg.src = thumb.dataset.img;
      modal.querySelectorAll('.charm-examples-modal__thumb').forEach(function(t) {
        t.classList.remove('charm-examples-modal__thumb--active');
      });
      thumb.classList.add('charm-examples-modal__thumb--active');
    });
  });

  function closeModal() {
    modal.remove();
    document.removeEventListener('keydown', onKeyDown);
  }

  function onKeyDown(e) {
    if (e.key === 'Escape') closeModal();
  }

  closeBtn.addEventListener('click', closeModal);
  backdrop.addEventListener('click', closeModal);
  document.addEventListener('keydown', onKeyDown);

  closeBtn.focus();
}


/* ── CharmCustomizer ────────────────────────────────────── */

class CharmCustomizer {
  constructor(el) {
    this.el = el;
    this.form = this._findForm();
    this.isSubmitting = false;
    this.bundleId = null;
    this.bundleCode = null;

    this.labels = {
      free:          el.dataset.labelFree          || 'Included',
      remove:        el.dataset.labelRemove         || '× Remove',
      engraving:     el.dataset.labelEngraving      || 'Personalization (optional)',
      includedCharm: el.dataset.labelIncludedCharm  || 'Personalize your charm',
      addMore:       el.dataset.labelAddMore        || '+ Add another — +$__PRICE__ each',
      invalidChar:           el.dataset.labelInvalidChar           || 'Character not available.',
      invalidCharTemplate:   el.dataset.labelInvalidCharTemplate   || '',
      addEngraving:          el.dataset.labelAddEngraving          || '+ Add',
      editEngraving:         el.dataset.labelEditEngraving         || '+ Edit',
      skipEngraving:         el.dataset.labelSkipEngraving         || 'Skip engraving',
      skipEngravingTemplate: el.dataset.labelSkipEngravingTemplate || 'Skip __NAME__',
      addAddon:      el.dataset.labelAddAddon       || '+ Add',
    };

    this.freeMap   = this._parseJsonMap(el.dataset.freeMapId);
    this.addonsMap = this._parseJsonMap(el.dataset.addonsMapId);

    this.freeEl   = el.querySelector('[data-charm-free-engraving]');
    this.addonsEl = el.querySelector('[data-charm-addons]');

    this.agreementEl       = el.querySelector('[data-customizer-agreement]');
    this.agreementCheckbox = this.agreementEl && this.agreementEl.querySelector('.customizer-agreement__checkbox');
    this.agreementErrorEl  = this.agreementEl && this.agreementEl.querySelector('.customizer-agreement__error');

    if (this.agreementCheckbox) {
      this.agreementCheckbox.addEventListener('change', () => this._hideAgreementError());
    }

    var idInput = this.form ? this.form.querySelector('[name="id"]') : null;
    this._currentVariantId = idInput ? parseInt(idInput.value, 10) : null;

    this.freeConfig = this._getFreeConfig(this._currentVariantId);
    this.freeSlot   = null;

    if (this.freeEl) {
      this._initFreeSection();
      if (this.freeConfig) this._openFreePanel();
    }

    this.addonItems = [];
    if (this.addonsEl) {
      this._buildAddonItems(this._getAddonsConfig(this._currentVariantId));
    }

    this._bindVariantChange();
    this._bindFormSubmit();
    this._initPriceDisplay();

    document.addEventListener('click', (e) => {
      if (!e.target.closest('.charm-char-select')) {
        this.el.querySelectorAll('.charm-char-select').forEach((sel) => {
          if (sel._closeDropdown) sel._closeDropdown();
        });
      }
    });
    window.addEventListener('scroll', (e) => {
      if (!e.target.closest('.charm-char-select__dropdown')) {
        this.el.querySelectorAll('.charm-char-select').forEach((sel) => {
          if (sel._closeDropdown) sel._closeDropdown();
        });
      }
    }, true);
  }

  // ── Utilities ────────────────────────────────────────────────────────────

  _parseJsonMap(mapId) {
    if (!mapId) return {};
    var scriptEl = document.getElementById(mapId);
    if (!scriptEl) return {};
    try { return JSON.parse(scriptEl.textContent) || {}; }
    catch (e) { console.warn('[CharmCustomizer] bad JSON in map:', mapId); return {}; }
  }

  _getFreeConfig(variantId) {
    return variantId ? (this.freeMap[String(variantId)] || null) : null;
  }

  _getAddonsConfig(variantId) {
    return variantId ? (this.addonsMap[String(variantId)] || []) : [];
  }

  _findForm() {
    var section = this.el.closest('[data-section-id]') || this.el.closest('product-form');
    if (section) return section.querySelector('form[action*="/cart/add"]');
    return document.querySelector('product-form form[action*="/cart/add"]')
      || document.querySelector('form[action*="/cart/add"]');
  }

  _closeAllSelects() {
    this.el.querySelectorAll('.charm-char-select').forEach((sel) => {
      if (sel._closeDropdown) sel._closeDropdown();
    });
  }

  // ── Free engraving section ────────────────────────────────────────────────

  _initFreeSection() {
    var rowAction = this.freeEl.querySelector('.charm-free-engraving__row-action');
    if (rowAction) rowAction.addEventListener('click', () => this._toggleFreePanel());
    this._syncFreeVisibility();
  }

  _syncFreeVisibility() {
    if (!this.freeEl) return;
    this.freeEl.hidden = !this.freeConfig;
  }

  _isFreeOpen() {
    var panel = this.freeEl && this.freeEl.querySelector('.charm-free-engraving__panel');
    return panel ? !panel.hasAttribute('hidden') : false;
  }

  _toggleFreePanel() {
    this._isFreeOpen() ? this._closeFreePanel() : this._openFreePanel();
  }

  _openFreePanel() {
    var rowAction = this.freeEl.querySelector('.charm-free-engraving__row-action');
    var row       = this.freeEl.querySelector('.charm-free-engraving__row');
    var panel     = this.freeEl.querySelector('.charm-free-engraving__panel');
    panel.removeAttribute('hidden');
    if (rowAction) rowAction.textContent = this.labels.skipEngraving;
    if (row) row.classList.add('charm-free-engraving__row--open');
    if (!this.freeSlot) {
      this.freeSlot = this._buildFreeSlot(panel);
    }
    this._updateAgreementVisibility();
  }

  _closeFreePanel(silent) {
    var rowAction = this.freeEl.querySelector('.charm-free-engraving__row-action');
    var row       = this.freeEl.querySelector('.charm-free-engraving__row');
    var panel     = this.freeEl.querySelector('.charm-free-engraving__panel');
    panel.setAttribute('hidden', '');
    if (rowAction) rowAction.textContent = this.labels.addEngraving;
    if (row) row.classList.remove('charm-free-engraving__row--open');
    this._destroyFreeSlot(panel);
    if (!silent) this._updateAgreementVisibility();
  }

  _buildFreeSlot(panel) {
    var container = panel.querySelector('.charm-free-engraving__slot-container');
    if (!container) return null;
    var cfg         = this.freeConfig;
    var charOptions = parseCharOptions(cfg.symbolSet || '[]');
    var singleLine  = cfg.singleLineSymbols === true;
    var maxChars    = cfg.maxEngraving || 1;
    var slot = { text: '', selections: Array(maxChars).fill(''), engraveErrorEl: null, el: null };

    var wrap = document.createElement('div');
    wrap.className = 'charm-slot__engraving';

    var labelRow = document.createElement('div');
    labelRow.className = 'charm-slot__label-row';
    var label = document.createElement('label');
    label.className = 'charm-slot__label';
    label.textContent = this.labels.engraving;
    labelRow.appendChild(label);
    var symbolImages  = cfg.symbolImages || [];
    var symbolContent = cfg.symbolContent || null;
    if (symbolImages.length) {
      var infoBtn = document.createElement('button');
      infoBtn.className = 'charm-slot__examples-link';
      infoBtn.type = 'button';
      infoBtn.textContent = 'Details';
      infoBtn.addEventListener('click', () => openImagesModal(symbolImages, '', symbolContent));
      labelRow.appendChild(infoBtn);
    }
    wrap.appendChild(labelRow);

    var row = document.createElement('div');
    row.className = 'charm-slot__selects';
    wrap.appendChild(row);

    if (singleLine) {
      var built = buildSingleLineInputEl({
        maxLength: maxChars,
        charOptions: charOptions,
        rawSymbolSet: cfg.symbolSet || '[]',
        hintText: this.labels.invalidChar,
        onInput: (value) => {
          slot.selections = Array(maxChars).fill('');
          Array.from(value).forEach((c, i) => { if (i < maxChars) slot.selections[i] = c; });
          slot.text = value;
          if (value && slot.engraveErrorEl) slot.engraveErrorEl.setAttribute('hidden', '');
          this._updateAgreementVisibility();
        },
      });
      row.appendChild(built.input);
      if (built.guide) row.appendChild(built.guide);
      row.appendChild(built.hint);
    } else {
      for (let i = 0; i < maxChars; i++) {
        row.appendChild(buildCharSelectEl(
          charOptions, i,
          (opt, selectWrap, trigger) => {
            slot.selections[i] = opt.cartValue;
            slot.text = slot.selections.join('');
            applySelectionToTrigger(opt, trigger);
            document.querySelectorAll('.charm-char-select__dropdown').forEach((dd) => markDropdownSelection(dd, opt.cartValue));
            selectWrap._closeDropdown();
            if (i === 0 && slot.engraveErrorEl) slot.engraveErrorEl.setAttribute('hidden', '');
            this._updateAgreementVisibility();
          },
          () => this._closeAllSelects()
        ));
      }
    }

    var errEl = document.createElement('p');
    errEl.className = 'charm-slot__engraving-error';
    errEl.setAttribute('hidden', '');
    errEl.textContent = 'Please add your personalization. If you choose to remove personalization your charm will come blank.';
    wrap.appendChild(errEl);
    slot.engraveErrorEl = errEl;
    slot.el = wrap;

    container.appendChild(wrap);
    return slot;
  }

  _destroyFreeSlot(panel) {
    var container = panel && panel.querySelector('.charm-free-engraving__slot-container');
    if (container) {
      container.querySelectorAll('.charm-char-select').forEach((sel) => {
        if (sel._removeDropdown) sel._removeDropdown();
      });
      container.innerHTML = '';
    }
    this.freeSlot = null;
  }

  // ── Add-ons section ───────────────────────────────────────────────────────

  _buildAddonItems(configs) {
    var heading = this.addonsEl.querySelector('.charm-addons__heading');
    // Clean up portaled dropdowns from existing items before clearing DOM
    this.addonItems.forEach((item) => {
      if (item.isEngravable && item.pickersEl) {
        item.pickersEl.querySelectorAll('.charm-char-select').forEach((sel) => {
          if (sel._removeDropdown) sel._removeDropdown();
        });
      }
    });
    this.addonsEl.innerHTML = '';
    if (heading) this.addonsEl.appendChild(heading);

    this.addonItems = [];
    if (!configs || !configs.length) {
      this.addonsEl.hidden = true;
      return;
    }
    this.addonsEl.hidden = false;

    configs.forEach((cfg, idx) => {
      var item = this._createAddonItem(cfg, idx);
      this.addonsEl.appendChild(item.el);
      this.addonItems.push(item);
    });
  }

  _createAddonItem(cfg, idx) {
    var available    = cfg.available !== false;
    var charmPrice   = cfg.charmPrice || 0;
    var maxCharms    = cfg.maxCharms || 5;
    var maxEngraving = cfg.maxEngraving || 1;
    var singleLine   = cfg.singleLineSymbols === true;
    var rawSymSet    = cfg.symbolSet;
    var symbolSetBlank = !rawSymSet || rawSymSet === '[]' || rawSymSet === '{}';
    var charOptions  = symbolSetBlank ? [] : parseCharOptions(rawSymSet);
    var titleText    = cfg.title || cfg.charmName || 'Charm';
    var priceStr     = moneyFormat(charmPrice);

    var imgHtml = cfg.charmImg
      ? '<img class="charm-addon-item__img" src="' + cfg.charmImg + '" alt="' + titleText + '" width="52" height="52" loading="lazy">'
      : '';

    var symbolImages  = cfg.symbolImages  || [];
    var symbolContent = cfg.symbolContent || null;
    var detailsHtml   = symbolImages.length
      ? '<button class="charm-slot__examples-link charm-addon-item__details-btn" type="button">Details</button>'
      : '';

    var isEngravable = charOptions.length > 0 || singleLine;

    var item = {
      cfg, idx, available, charmPrice, maxCharms, maxEngraving, charOptions, singleLine, isEngravable,
      qty: 0, charValues: [], engraveErrors: [],
      el: null, addBtn: null, panelEl: null, pickersEl: null,
      stepperEl: null, stepperQtyEl: null, stepperDecBtn: null, stepperIncBtn: null,
    };

    var el = document.createElement('div');
    el.className = 'charm-addon-item';
    el.innerHTML = [
      '<div class="charm-addon-item__header">',
        '<div class="charm-addon-item__header-left">',
          imgHtml,
          '<div class="charm-addon-item__header-text">',
            '<span class="charm-addon-item__title">' + titleText + '</span>',
            '<span class="charm-addon-item__price">+' + priceStr + ' each</span>',
            detailsHtml,
          '</div>',
        '</div>',
        '<button class="charm-addon-item__add-btn customizer-add-btn" type="button">' + this.labels.addAddon + '</button>',
        '<div class="charm-addon-item__stepper" hidden>',
          '<button class="charm-addon-item__stepper-dec" type="button" aria-label="Remove one">&#8722;</button>',
          '<span class="charm-addon-item__stepper-qty">1</span>',
          '<button class="charm-addon-item__stepper-inc" type="button" aria-label="Add one">+</button>',
        '</div>',
      '</div>',
      '<div class="charm-addon-item__panel" hidden>',
        '<div class="charm-addon-item__pickers"></div>',
      '</div>',
    ].join('');

    item.el           = el;
    item.addBtn        = el.querySelector('.charm-addon-item__add-btn');

    var detailsBtn = el.querySelector('.charm-addon-item__details-btn');
    if (detailsBtn) {
      detailsBtn.addEventListener('click', () => openImagesModal(symbolImages, titleText, symbolContent));
    }
    item.panelEl       = el.querySelector('.charm-addon-item__panel');
    item.pickersEl     = el.querySelector('.charm-addon-item__pickers');
    item.stepperEl     = el.querySelector('.charm-addon-item__stepper');
    item.stepperQtyEl  = el.querySelector('.charm-addon-item__stepper-qty');
    item.stepperDecBtn = el.querySelector('.charm-addon-item__stepper-dec');
    item.stepperIncBtn = el.querySelector('.charm-addon-item__stepper-inc');

    item.addBtn.addEventListener('click', () => this._setAddonQty(item, 1));
    item.stepperDecBtn.addEventListener('click', () => this._setAddonQty(item, item.qty - 1));
    item.stepperIncBtn.addEventListener('click', () => this._setAddonQty(item, item.qty + 1));

    if (!available) {
      item.addBtn.setAttribute('disabled', '');
      item.addBtn.textContent = 'Sold Out';
    }

    return item;
  }

  _setAddonQty(item, newQty) {
    newQty = Math.max(0, Math.min(newQty, item.maxCharms));
    var oldQty = item.qty;
    if (newQty === oldQty) return;

    if (newQty > oldQty) {
      if (oldQty === 0) {
        item.addBtn.setAttribute('hidden', '');
        item.stepperEl.removeAttribute('hidden');
        if (item.isEngravable) item.panelEl.removeAttribute('hidden');
      }
      for (var i = oldQty; i < newQty; i++) {
        item.charValues.push('');
        if (item.isEngravable) this._addPickerRow(item, i);
      }
    } else {
      for (var i = oldQty - 1; i >= newQty; i--) {
        if (item.isEngravable) this._removePickerRow(item, i);
        item.charValues.pop();
      }
      if (newQty === 0) {
        item.addBtn.removeAttribute('hidden');
        item.stepperEl.setAttribute('hidden', '');
        item.panelEl.setAttribute('hidden', '');
      }
    }

    item.qty = newQty;

    if (newQty > 0) {
      item.stepperQtyEl.textContent = String(newQty);
      item.stepperIncBtn.disabled = newQty >= item.maxCharms;
      item.stepperDecBtn.disabled = false;
    }

    this._updateAgreementVisibility();
    this._updatePriceDisplay();
  }

  _addPickerRow(item, unitIdx) {
    var row = document.createElement('div');
    row.className = 'charm-addon-item__picker-row';

    var labelEl = document.createElement('div');
    labelEl.className = 'charm-addon-item__picker-label';
    labelEl.textContent = 'Charm ' + (unitIdx + 1);
    row.appendChild(labelEl);

    var selectsWrap = document.createElement('div');
    selectsWrap.className = 'charm-addon-item__picker-selects';
    row.appendChild(selectsWrap);

    var errEl;

    var clearBtn = document.createElement('button');
    clearBtn.type = 'button';
    clearBtn.className = 'charm-addon-item__char-clear';
    clearBtn.textContent = 'Clear';
    clearBtn.setAttribute('hidden', '');

    var updateClearBtn = () => {
      if (item.charValues[unitIdx]) {
        clearBtn.removeAttribute('hidden');
      } else {
        clearBtn.setAttribute('hidden', '');
      }
    };

    var buildSelects = () => {
      selectsWrap.querySelectorAll('.charm-char-select').forEach(function(sel) {
        if (sel._removeDropdown) sel._removeDropdown();
      });
      while (selectsWrap.firstChild) selectsWrap.removeChild(selectsWrap.firstChild);
      for (let charIdx = 0; charIdx < item.maxEngraving; charIdx++) {
        selectsWrap.appendChild(buildCharSelectEl(
          item.charOptions, charIdx,
          (opt, sw, trigger) => {
            item.charValues[unitIdx] = opt.cartValue;
            applySelectionToTrigger(opt, trigger);
            document.querySelectorAll('.charm-char-select__dropdown').forEach((dd) => markDropdownSelection(dd, opt.cartValue));
            sw._closeDropdown();
            if (charIdx === 0 && errEl) errEl.setAttribute('hidden', '');
            updateClearBtn();
            this._updateAgreementVisibility();
          },
          () => this._closeAllSelects()
        ));
      }
    };

    if (item.singleLine) {
      var built = buildSingleLineInputEl({
        maxLength: item.maxEngraving,
        charOptions: item.charOptions,
        rawSymbolSet: item.cfg.symbolSet || '[]',
        hintText: this.labels.invalidChar,
        onInput: (value) => {
          item.charValues[unitIdx] = value;
          if (value && errEl) errEl.setAttribute('hidden', '');
          updateClearBtn();
          this._updateAgreementVisibility();
        },
      });
      selectsWrap.appendChild(built.input);
      if (built.guide) selectsWrap.appendChild(built.guide);
      selectsWrap.appendChild(built.hint);
    } else {
      buildSelects();
    }

    clearBtn.addEventListener('click', () => {
      if (item.singleLine) {
        var input = selectsWrap.querySelector('input[type="text"]');
        if (input) input.value = '';
      } else {
        buildSelects();
      }
      item.charValues[unitIdx] = '';
      updateClearBtn();
      this._updateAgreementVisibility();
    });

    errEl = document.createElement('p');
    errEl.className = 'charm-slot__engraving-error';
    errEl.setAttribute('hidden', '');
    errEl.textContent = 'Please select a character.';
    row.appendChild(errEl);
    item.engraveErrors[unitIdx] = errEl;

    row.appendChild(clearBtn);
    item.pickersEl.appendChild(row);
  }

  _removePickerRow(item, unitIdx) {
    var rows = item.pickersEl ? item.pickersEl.querySelectorAll('.charm-addon-item__picker-row') : [];
    var row = rows[unitIdx];
    if (!row) return;
    row.querySelectorAll('.charm-char-select').forEach((sel) => {
      if (sel._removeDropdown) sel._removeDropdown();
    });
    row.remove();
    item.engraveErrors.splice(unitIdx, 1);
  }

  // ── Agreement ────────────────────────────────────────────────────────────

  _anyEngravingActive() {
    if (this._isFreeOpen()) return true;
    return this.addonItems.some((item) => item.qty > 0);
  }

  _updateAgreementVisibility() {
    if (!this.agreementEl) return;
    if (this._anyEngravingActive()) {
      this.agreementEl.removeAttribute('hidden');
    } else {
      this.agreementEl.setAttribute('hidden', '');
      if (this.agreementCheckbox) this.agreementCheckbox.checked = false;
      this._hideAgreementError();
    }
  }

  _showAgreementError() {
    if (this.agreementErrorEl) this.agreementErrorEl.removeAttribute('hidden');
    if (this.agreementEl) this.agreementEl.classList.add('customizer-agreement--error');
    if (this.agreementEl) {
      requestAnimationFrame(() => {
        this.agreementEl.scrollIntoView({ behavior: 'smooth', block: 'center' });
      });
    }
  }

  _hideAgreementError() {
    if (this.agreementErrorEl) this.agreementErrorEl.setAttribute('hidden', '');
    if (this.agreementEl) this.agreementEl.classList.remove('customizer-agreement--error');
  }

  // ── Variant change ────────────────────────────────────────────────────────

  _bindVariantChange() {
    if (!this.form) return;
    var idInput = this.form.querySelector('[name="id"]');
    if (!idInput) return;
    idInput.addEventListener('change', () => {
      var newId = parseInt(idInput.value, 10);
      if (!newId || newId === this._currentVariantId) return;
      this._currentVariantId = newId;
      this._onVariantChange(newId);
    });
  }

  _onVariantChange(variantId) {
    this.freeConfig = this._getFreeConfig(variantId);
    if (this.freeEl && this.freeConfig) {
      var typeName = this.freeConfig.customizationTypeName || 'Engraving';
      // Sync all labels that vary per variant's metaobject
      var rowKey = this.freeEl.querySelector('.charm-free-engraving__row-key');
      if (rowKey) rowKey.textContent = typeName;
      this.labels.skipEngraving = this.labels.skipEngravingTemplate.replace('__NAME__', typeName);
      if (this.labels.invalidCharTemplate) {
        this.labels.invalidChar = this.labels.invalidCharTemplate.replace('__NAME__', typeName);
      }
      if (this.freeConfig.charLabel) {
        this.labels.engraving = this.freeConfig.charLabel;
      }
    }
    if (this.freeEl) {
      if (this._isFreeOpen()) this._closeFreePanel(true);
      this._syncFreeVisibility();
      if (this.freeConfig) this._openFreePanel();
    }
    if (this.addonsEl) {
      this._buildAddonItems(this._getAddonsConfig(variantId));
    }
    this._updateAgreementVisibility();
    this._updatePriceDisplay();
  }

  // ── ATC price display ─────────────────────────────────────────────────────

  _findAtcButton() {
    // Use getAttribute to bypass HTML named-access: form.id is shadowed by input[name="id"]
    if (this.form) {
      var formId = this.form.getAttribute('id');
      if (formId) {
        var bb = document.querySelector('buy-buttons[form="' + formId + '"]');
        if (bb) {
          var btn = bb.querySelector('button[type="submit"]');
          if (btn) return btn;
        }
      }
    }
    // Fallback: Prestige uses product-rerender, not [data-section-id]
    var scope = this.el.closest('product-rerender') || this.el.closest('product-form') || document;
    return scope.querySelector('buy-buttons button[type="submit"]');
  }

  _initPriceDisplay() {
    this.atcBtn = this._findAtcButton();
    if (!this.atcBtn) return;
    this.priceDisplay = document.createElement('span');
    this.priceDisplay.className = 'charm-price-display';
    this.priceDisplay.hidden = true;
    this.atcBtn.appendChild(this.priceDisplay);
  }

  _updatePriceDisplay() {
    if (!this.priceDisplay) return;
    var addonTotal = this.addonItems.reduce(function(sum, item) {
      return sum + item.qty * item.charmPrice;
    }, 0);
    if (addonTotal > 0) {
      var basePrice = parseInt(this.el.dataset.basePrice, 10) || 0;
      this.priceDisplay.textContent = 'Total: ' + moneyFormat(basePrice + addonTotal);
      this.priceDisplay.hidden = false;
    } else {
      this.priceDisplay.hidden = true;
    }
  }

  // ── Form submit ──────────────────────────────────────────────────────────

  _bindFormSubmit() {
    if (!this.form) return;
    this.form.addEventListener('submit', (e) => {
      if (!this._anyEngravingActive()) return;
      if (this.isSubmitting) { e.preventDefault(); e.stopImmediatePropagation(); return; }

      // Validate free slot
      if (this._isFreeOpen() && this.freeSlot && !this.freeSlot.selections[0]) {
        e.preventDefault(); e.stopImmediatePropagation();
        this.freeSlot.engraveErrorEl.removeAttribute('hidden');
        requestAnimationFrame(() => this.freeSlot.engraveErrorEl.scrollIntoView({ behavior: 'smooth', block: 'center' }));
        return;
      }

      // Validate addon items — only engravable items require a character selection
      for (var i = 0; i < this.addonItems.length; i++) {
        var addonItem = this.addonItems[i];
        if (addonItem.qty === 0 || !addonItem.isEngravable) continue;
        for (var j = 0; j < addonItem.qty; j++) {
          if (!addonItem.charValues[j]) {
            e.preventDefault(); e.stopImmediatePropagation();
            var errEl = addonItem.engraveErrors[j];
            if (errEl) {
              errEl.removeAttribute('hidden');
              requestAnimationFrame(() => errEl.scrollIntoView({ behavior: 'smooth', block: 'center' }));
            }
            return;
          }
        }
      }

      // Validate agreement
      if (this.agreementCheckbox && !this.agreementCheckbox.checked) {
        e.preventDefault(); e.stopImmediatePropagation();
        this._showAgreementError();
        return;
      }

      e.preventDefault(); e.stopImmediatePropagation();
      this._submitBundle();
    }, true);
  }

  async _submitBundle() {
    if (this.isSubmitting) return;
    this.isSubmitting = true;
    var submitBtn = this.form.querySelector('[name="add"], [type="submit"]');
    if (submitBtn) submitBtn.setAttribute('aria-busy', 'true');

    this.bundleId   = generateUUID();
    this.bundleCode = generateBundleCode();

    var baseVariantId = parseInt(this.form.querySelector('[name="id"]').value, 10);
    var qtyInput      = this.form.querySelector('[name="quantity"]');
    var baseQty       = qtyInput ? (parseInt(qtyInput.value, 10) || 1) : 1;
    var agreementNote = 'Confirmed — personalization cannot be modified, returned, or exchanged';

    var baseProps = {
      _bundle_id: this.bundleId,
      'Group ID': this.bundleCode,
    };
    if (this._isFreeOpen() && this.freeSlot && this.freeSlot.text) {
      baseProps['Personalization'] = this.freeSlot.text;
      baseProps['Personalization Agreement'] = agreementNote;
    }

    // Pick up any hidden property inputs in the form (e.g. pre-order) so they
    // are not lost when the charm customizer bypasses the normal form submit.
    this.form.querySelectorAll('input[type="hidden"][name^="properties["]').forEach(function(inp) {
      var match = inp.name.match(/^properties\[(.+)\]$/);
      if (match && match[1].indexOf('__shopify') === -1) baseProps[match[1]] = inp.value;
    });

    var items = [{ id: baseVariantId, quantity: baseQty, properties: baseProps }];

    this.addonItems.forEach((addonItem) => {
      if (addonItem.qty === 0) return;
      for (var i = 0; i < addonItem.qty; i++) {
        var props = {
          _bundle_id: this.bundleId,
          _charm_slot: i + 1,
          'Group ID': this.bundleCode,
          'Personalization Agreement': agreementNote,
        };
        if (addonItem.charValues[i]) props['Personalization'] = addonItem.charValues[i];
        items.push({ id: addonItem.cfg.variantId, quantity: 1, properties: props });
      }
    });

    var sectionsToRequest = [];
    document.documentElement.dispatchEvent(new CustomEvent('cart:prepare-bundled-sections', {
      bubbles: true,
      detail: { sections: sectionsToRequest },
    }));

    var body = { items };
    if (sectionsToRequest.length) body.sections = sectionsToRequest.join(',');

    try {
      var res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(body),
      });
      if (!res.ok) {
        var errData = await res.json().catch(() => ({}));
        throw new Error((errData && errData.description) || 'Could not add to cart.');
      }
      var resJson  = await res.json();
      var cartJson = await fetch('/cart.js').then((r) => r.json());
      if (resJson.sections) cartJson.sections = resJson.sections;

      this.form.dispatchEvent(new CustomEvent('variant:add', {
        bubbles: true,
        detail: { items: resJson.items, cart: cartJson, onSuccessDo: null },
      }));
      document.documentElement.dispatchEvent(new CustomEvent('cart:change', {
        bubbles: true,
        detail: { baseEvent: 'variant:add', onSuccessDo: null, cart: cartJson },
      }));
    } catch (err) {
      console.error('[CharmCustomizer]', err);
      alert(err.message || 'Could not add to cart. Please try again.');
    } finally {
      this.isSubmitting = false;
      if (submitBtn) submitBtn.removeAttribute('aria-busy');
    }
  }
}

/* ── LeatherCustomizer ──────────────────────────────────── */

class LeatherCustomizer {
  constructor(el) {
    this.el = el;
    this._originalVariantId = null;
    this._isEnabled = false;

    // Read per-variant config from embedded JSON
    var configEl = el.querySelector('[data-leather-customizer-config]');
    this._variantConfigs = {};
    if (configEl) {
      try { this._variantConfigs = JSON.parse(configEl.textContent); } catch (e) {}
    }

    // Find form and current variant ID
    var section = el.closest('[data-section-id]');
    this._form = (section ? section.querySelector('form[action*="/cart/add"]') : null)
      || document.querySelector('product-form form[action*="/cart/add"]');
    var idInput = this._form ? this._form.querySelector('[name="id"]') : null;
    this._currentBaseVariantId = idInput ? parseInt(idInput.value, 10) : 0;

    // Cache DOM references
    this.toggleBtn = el.querySelector('.leather-customizer__add-btn');
    this.panel = el.querySelector('.leather-customizer__panel');
    this.selectsRow = el.querySelector('.leather-customizer__char-selects');
    this.textInput = el.querySelector('.leather-customizer__text-input');
    this.fontInput = el.querySelector('.leather-customizer__font-input');
    this.finishInput = el.querySelector('.leather-customizer__finish-input');
    this.priceDeltaEl = el.querySelector('.leather-customizer__price-delta');
    this.charErrorEl = el.querySelector('.leather-customizer__char-error');
    this.charClearBtn = el.querySelector('.leather-customizer__char-clear');
    this.agreementCheckbox = el.querySelector('.customizer-agreement__checkbox');
    this.agreementErrorEl = el.querySelector('.customizer-agreement__error');
    this.agreementInput = el.querySelector('.leather-customizer__agreement-input');
    this.labelInvalidChar = el.dataset.labelInvalidChar || 'That character isn\'t available for engraving.';

    // Move property inputs into the cart form — Prestige renders the block
    // outside the <form>, so inputs not inside it are excluded from FormData.
    if (this._form) {
      [this.textInput, this.fontInput, this.finishInput, this.agreementInput].forEach((inp) => {
        if (inp) this._form.appendChild(inp);
      });
    }

    // Apply config for the initially selected variant
    this._applyVariantConfig(this._currentBaseVariantId);

    // Protection: if the embossed variant is ordered first in Shopify admin,
    // the page loads with an embossed ID selected. Detect this and silently
    // correct the form to the non-embossed base so cart adds the right item.
    if (this.el.hidden && idInput) {
      var baseId = this._findBaseForEmbossVariant(this._currentBaseVariantId);
      if (baseId) {
        this._currentBaseVariantId = baseId;
        idInput.value = baseId;
        this._applyVariantConfig(baseId);
      }
    }

    this.toggleBtn.addEventListener('click', () => this._onToggle());

    if (this.charClearBtn) {
      this.charClearBtn.addEventListener('click', () => this._clearCharSelects());
    }

    if (this.agreementCheckbox) {
      this.agreementCheckbox.addEventListener('change', () => this._hideAgreementError());
    }
    this._bindSubmitValidation();

    // Listen for variant changes via the hidden variant-ID input.
    // Prestige's selectCombination() sets form.id.value and dispatches "change" on
    // that input only AFTER its async section-fetch resolves — which is why the
    // radio-change + 50ms timeout approach was always reading the stale old ID.
    // Listening here directly (same pattern as CharmCustomizer) fires with the
    // correct new ID after the fetch completes.
    if (idInput) {
      idInput.addEventListener('change', () => {
        var newId = parseInt(idInput.value, 10);
        if (!newId || newId === this._currentBaseVariantId) return;
        // Only skip if this change is our own emboss toggle swap (not an external pick)
        if (newId === this.embossVariantId && this._isEnabled) return;
        this._onExternalVariantChange(newId);
      });
    }

    document.addEventListener('click', (e) => {
      if (!e.target.closest('.charm-char-select')) closeAllCharSelectsIn(this.el);
    });
    window.addEventListener('scroll', (e) => {
      if (!e.target.closest('.charm-char-select__dropdown')) closeAllCharSelectsIn(this.el);
    }, true);
  }

  _applyVariantConfig(variantId) {
    var config = this._variantConfigs[variantId];
    if (!config || !config.enabled) {
      this.el.hidden = true;
      return;
    }
    this.el.hidden = false;
    this.embossVariantId = config.embossVariantId || 0;
    this.embossPrice = config.embossPrice || 0;
    this.basePrice = config.basePrice || 0;
    this.maxChars = config.maxChars || 1;
    this.charOptions = parseCharOptions(JSON.stringify(config.symbolSet || ['A-Z']));
    this.singleLineMode = config.singleLineSymbols === true;
    this._rawSymbolSet = config.symbolSet || ['A-Z'];
    this.charSelections = Array(this.maxChars).fill('');
    this.fontOptions = Array.isArray(config.fontOptions) ? config.fontOptions : ['Serif', 'Sans Serif'];
    this.finishOptions = Array.isArray(config.finishOptions) ? config.finishOptions : ['Hot Stamp', 'Laser', 'Deboss'];
    this.selectedFont = this.fontOptions[0] || '';
    this.selectedFinish = this.finishOptions[0] || '';
    this.symbolImages  = config.symbolImages  || [];
    this.finishImages  = config.finishImages  || [];
    this.fontImages    = config.fontImages    || [];
    this.symbolContent = config.symbolContent || null;
    this.finishContent = config.finishContent || null;
    this.fontContent   = config.fontContent   || null;

    this._buildCharSelects();
    this._updateClearBtn();
    var fontsGroup = this.el.querySelector('[data-leather-fonts]');
    var finishesGroup = this.el.querySelector('[data-leather-finishes]');
    if (fontsGroup) fontsGroup.querySelector('.leather-customizer__pills').innerHTML = '';
    if (finishesGroup) finishesGroup.querySelector('.leather-customizer__pills').innerHTML = '';
    this._buildPills(fontsGroup, this.fontOptions, 'font');
    this._buildPills(finishesGroup, this.finishOptions, 'finish');

    var headerExamplesBtn = this.el.querySelector('.leather-customizer__header-examples');
    var charBtn   = this.el.querySelector('.leather-customizer__char-row .leather-customizer__examples-link');
    var fontBtn   = this.el.querySelector('[data-leather-fonts] .leather-customizer__examples-link');
    var finishBtn = this.el.querySelector('[data-leather-finishes] .leather-customizer__examples-link');
    this._wireExamplesLink(headerExamplesBtn, this.symbolImages, this.symbolContent, 'Character Examples');
    this._wireExamplesLink(charBtn,   this.symbolImages, this.symbolContent, 'Character Examples');
    this._wireExamplesLink(fontBtn,   this.fontImages,   this.fontContent,   'Font Examples');
    this._wireExamplesLink(finishBtn, this.finishImages, this.finishContent, 'Finish Examples');

    this._updatePriceDelta();
  }

  _onExternalVariantChange(newBaseVariantId) {
    // If Prestige picked an embossed variant (because it's first in admin order),
    // find the non-embossed base and silently correct the form.
    var effectiveId = newBaseVariantId;
    var cfg = this._variantConfigs[newBaseVariantId];
    if (!cfg || !cfg.enabled) {
      var baseId = this._findBaseForEmbossVariant(newBaseVariantId);
      if (baseId) {
        effectiveId = baseId;
        var idInput = this._form ? this._form.querySelector('[name="id"]') : null;
        if (idInput) idInput.value = baseId;
      }
    }

    // User picked a different product variant (color/size) — reset embossing first
    if (this._isEnabled) {
      this._isEnabled = false;
      this.toggleBtn.textContent = '+ Add';
      this.toggleBtn.classList.remove('customizer-add-btn--added');
      this.panel.setAttribute('hidden', '');
      this._enableInputs(false);
      this._originalVariantId = null;
    }
    this._currentBaseVariantId = effectiveId;
    this._applyVariantConfig(effectiveId);
    this._updatePriceDelta();
  }

  _findBaseForEmbossVariant(embossVariantId) {
    for (var id in this._variantConfigs) {
      var c = this._variantConfigs[id];
      if (c.enabled && c.embossVariantId === embossVariantId) {
        return parseInt(id, 10);
      }
    }
    return 0;
  }

  _wireExamplesLink(btn, images, content, title) {
    if (!btn) return;
    var hasImages = images && images.length > 0;
    var hasContent = !!content;
    if (hasImages || hasContent) {
      btn.removeAttribute('hidden');
      if (btn._examplesHandler) btn.removeEventListener('click', btn._examplesHandler);
      btn._examplesHandler = () => openImagesModal(images, title, content);
      btn.addEventListener('click', btn._examplesHandler);
    } else {
      btn.setAttribute('hidden', '');
    }
  }

  _parseOptions(raw, fallback) {
    try {
      var parsed = JSON.parse(raw);
      if (Array.isArray(parsed)) return parsed;
    } catch (e) {}
    return fallback;
  }

  _buildCharSelects() {
    if (!this.selectsRow) return;
    this.selectsRow.innerHTML = '';
    this._singleLineInput = null;
    if (this.singleLineMode) {
      this._buildSingleLineInput();
    } else {
      for (var i = 0; i < this.maxChars; i++) {
        this.selectsRow.appendChild(this._buildOneCharSelect(i));
      }
    }
  }

  _buildSingleLineInput() {
    var self = this;
    var els = buildSingleLineInputEl({
      maxLength: this.maxChars,
      charOptions: this.charOptions,
      rawSymbolSet: this._rawSymbolSet,
      hintText: this.labelInvalidChar,
      onInput: function(value) {
        self.charSelections = Array(self.maxChars).fill('');
        Array.from(value).forEach(function(c, i) {
          if (i < self.maxChars) self.charSelections[i] = c;
        });
        self.textInput.value = value;
        self._updateClearBtn();
        if (value.length > 0) self._hideCharError();
      }
    });
    this.selectsRow.appendChild(els.input);
    if (els.guide) this.selectsRow.appendChild(els.guide);
    this.selectsRow.appendChild(els.hint);
    this._singleLineInput = els.input;
  }

  _buildOneCharSelect(index) {
    var self = this;
    return buildCharSelectEl(
      this.charOptions,
      index,
      function(opt, wrap, trigger) { self._onCharSelect(index, opt, wrap, trigger); },
      function() { closeAllCharSelectsIn(self.el); }
    );
  }

  _clearCharSelects() {
    this.charSelections = Array(this.maxChars).fill('');
    if (this.singleLineMode) {
      if (this._singleLineInput) this._singleLineInput.value = '';
    } else if (this.selectsRow) {
      this.selectsRow.querySelectorAll('.charm-char-select').forEach(function(sel) {
        if (sel._removeDropdown) sel._removeDropdown();
      });
      this._buildCharSelects();
    }
    this._syncTextInput();
    this._hideCharError();
    this._updateClearBtn();
  }

  _updateClearBtn() {
    if (!this.charClearBtn) return;
    var hasAny = this.charSelections.some(function(v) { return v !== ''; });
    hasAny ? this.charClearBtn.removeAttribute('hidden') : this.charClearBtn.setAttribute('hidden', '');
  }

  _onCharSelect(charIndex, opt, wrap, trigger) {
    this.charSelections[charIndex] = opt.cartValue;

    applySelectionToTrigger(opt, trigger);

    document.querySelectorAll('.charm-char-select__dropdown').forEach(function(dd) {
      markDropdownSelection(dd, opt.cartValue);
    });

    wrap._closeDropdown();
    if (charIndex === 0) this._hideCharError();
    this._syncTextInput();
    this._updateClearBtn();
  }

  _buildPills(groupEl, options, type) {
    if (!groupEl) return;
    var container = groupEl.querySelector('.leather-customizer__pills');
    if (!container) return;

    options.forEach((opt, i) => {
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'leather-pill' + (i === 0 ? ' leather-pill--selected' : '');
      btn.textContent = opt;
      btn.addEventListener('click', () => {
        container.querySelectorAll('.leather-pill').forEach((b) => b.classList.remove('leather-pill--selected'));
        btn.classList.add('leather-pill--selected');
        if (type === 'font') {
          this.selectedFont = opt;
          if (this.fontInput) this.fontInput.value = opt;
        } else {
          this.selectedFinish = opt;
          if (this.finishInput) this.finishInput.value = opt;
        }
      });
      container.appendChild(btn);
    });

    if (type === 'font' && this.fontInput) this.fontInput.value = this.fontOptions[0] || '';
    if (type === 'finish' && this.finishInput) this.finishInput.value = this.finishOptions[0] || '';
  }

  _onToggle() {
    this._isEnabled ? this._disable() : this._enable();
  }

  _enable() {
    this._isEnabled = true;
    this.toggleBtn.textContent = '× Remove';
    this.toggleBtn.classList.add('customizer-add-btn--added');
    this.panel.removeAttribute('hidden');
    this._enableInputs(true);
    this._swapVariant(true);
    this._updatePriceDelta();
  }

  _disable() {
    this._isEnabled = false;
    this.toggleBtn.textContent = '+ Add';
    this.toggleBtn.classList.remove('customizer-add-btn--added');
    this.panel.setAttribute('hidden', '');
    this._enableInputs(false);
    if (this.agreementCheckbox) this.agreementCheckbox.checked = false;
    if (this.agreementInput) this.agreementInput.value = '';
    this._hideAgreementError();
    this.charSelections = Array(this.maxChars).fill('');
    if (this.selectsRow) {
      this.selectsRow.querySelectorAll('.charm-char-select').forEach(function(sel) {
        if (sel._removeDropdown) sel._removeDropdown();
      });
      this._buildCharSelects();
    }
    this._syncTextInput();
    this._updateClearBtn();
    this._swapVariant(false);
    this._updatePriceDelta();
  }

  _enableInputs(on) {
    [this.textInput, this.fontInput, this.finishInput, this.agreementInput].forEach((inp) => {
      if (!inp) return;
      on ? inp.removeAttribute('disabled') : inp.setAttribute('disabled', '');
    });
  }

  _syncTextInput() {
    if (!this.textInput) return;
    this.textInput.value = this.charSelections.join('');
  }

  _swapVariant(toEmbossing) {
    if (!this._form) return;
    var hiddenIdInput = this._form.querySelector('[name="id"]');
    if (!hiddenIdInput) return;

    if (toEmbossing) {
      if (this.embossVariantId) {
        hiddenIdInput.value = this.embossVariantId;
        hiddenIdInput.dispatchEvent(new Event('change', { bubbles: true }));
      }
    } else {
      if (this._currentBaseVariantId) {
        hiddenIdInput.value = this._currentBaseVariantId;
        hiddenIdInput.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }
  }

  _updatePriceDelta() {
    this._updateButtonLabel();
    if (!this.priceDeltaEl) return;
    if (!this.embossPrice || !this.basePrice) {
      this.priceDeltaEl.hidden = true;
      return;
    }
    var delta = this.embossPrice - this.basePrice;
    if (delta > 0) {
      this.priceDeltaEl.textContent = '+ ' + moneyFormat(delta);
      this.priceDeltaEl.hidden = false;
    } else {
      this.priceDeltaEl.hidden = true;
    }
  }

  _findAtcButton() {
    if (this._form) {
      var formId = this._form.getAttribute('id');
      if (formId) {
        var bb = document.querySelector('buy-buttons[form="' + formId + '"]');
        if (bb) {
          var btn = bb.querySelector('button[type="submit"]');
          if (btn) return btn;
        }
      }
    }
    var scope = this.el.closest('product-rerender') || document;
    return scope.querySelector('buy-buttons button[type="submit"]');
  }

  _updateButtonLabel() {
    var atcBtn = this._findAtcButton();
    if (!atcBtn) return;
    var existing = atcBtn.querySelector('.leather-price-display');
    if (this._isEnabled && this.embossPrice && this.basePrice) {
      var delta = this.embossPrice - this.basePrice;
      if (delta > 0) {
        if (!existing) {
          var span = document.createElement('span');
          span.className = 'leather-price-display';
          atcBtn.appendChild(span);
          existing = span;
        }
        existing.textContent = ' +' + moneyFormat(delta) + ' personalization';
        return;
      }
    }
    if (existing) existing.remove();
  }

  _bindSubmitValidation() {
    if (!this._form) return;
    this._form.addEventListener('submit', (e) => {
      if (!this._isEnabled) return;
      if (!this.charSelections[0]) {
        e.preventDefault();
        e.stopImmediatePropagation();
        this._showCharError();
        return;
      }
      if (this.agreementCheckbox && !this.agreementCheckbox.checked) {
        e.preventDefault();
        e.stopImmediatePropagation();
        this._showAgreementError();
        return;
      }
      if (this.agreementInput) {
        this.agreementInput.value = 'Confirmed — personalization cannot be modified, returned, or exchanged';
      }
    }, true);
  }

  _showCharError() {
    if (this.charErrorEl) this.charErrorEl.removeAttribute('hidden');
    var scrollTarget = this.charErrorEl;
    if (this.singleLineMode) {
      if (this._singleLineInput) {
        this._singleLineInput.classList.add('customizer__single-line-input--error');
        scrollTarget = scrollTarget || this._singleLineInput;
      }
    } else {
      var firstSelect = this.selectsRow && this.selectsRow.querySelector('.charm-char-select');
      if (firstSelect) firstSelect.classList.add('charm-char-select--error');
      scrollTarget = scrollTarget || firstSelect;
    }
    if (scrollTarget) {
      requestAnimationFrame(() => {
        scrollTarget.scrollIntoView({ behavior: 'smooth', block: 'center' });
      });
    }
  }

  _hideCharError() {
    if (this.charErrorEl) this.charErrorEl.setAttribute('hidden', '');
    if (this.singleLineMode) {
      if (this._singleLineInput) {
        this._singleLineInput.classList.remove('customizer__single-line-input--error');
      }
    } else {
      var firstSelect = this.selectsRow && this.selectsRow.querySelector('.charm-char-select');
      if (firstSelect) firstSelect.classList.remove('charm-char-select--error');
    }
  }

  _showAgreementError() {
    if (this.agreementErrorEl) this.agreementErrorEl.removeAttribute('hidden');
    var row = this.el.querySelector('[data-customizer-agreement]');
    if (row) row.classList.add('customizer-agreement--error');
    var scrollTarget = this.agreementErrorEl || row;
    if (scrollTarget) {
      requestAnimationFrame(() => {
        scrollTarget.scrollIntoView({ behavior: 'smooth', block: 'center' });
      });
    }
  }

  _hideAgreementError() {
    if (this.agreementErrorEl) this.agreementErrorEl.setAttribute('hidden', '');
    var row = this.el.querySelector('[data-customizer-agreement]');
    if (row) row.classList.remove('customizer-agreement--error');
  }
}

/* ── Orphan cleanup ─────────────────────────────────────── */

async function cleanupCharmOrphans() {
  try {
    var cart = await fetch('/cart.js').then((r) => r.json());
    var items = cart.items || [];

    var bundleIds = new Set();
    var charmLines = [];

    items.forEach((item) => {
      var props = item.properties || {};
      var bid = props['_bundle_id'];
      if (!bid) return;

      var isCharm = props['_charm_slot'] !== undefined;
      if (isCharm) {
        charmLines.push({ key: item.key, bundleId: bid });
      } else {
        bundleIds.add(bid);
      }
    });

    var orphans = charmLines.filter((c) => !bundleIds.has(c.bundleId));
    if (orphans.length === 0) return;

    // update.js handles multiple removals in one request (more efficient than
    // looping change.js calls for the orphan batch case)
    var updates = {};
    orphans.forEach((o) => { updates[o.key] = 0; });

    await fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ updates: updates })
    });
  } catch (e) {
    console.error('[CharmOrphan] cleanup failed:', e);
  }
}

/* ── Scroll-into-view animation ─────────────────────────── */

function attachCustomizerAnimation(el, delay) {
  el.classList.add('customizer--will-animate');
  var observer = new IntersectionObserver(function(entries, obs) {
    entries.forEach(function(entry) {
      if (!entry.isIntersecting) return;
      setTimeout(function() {
        el.classList.remove('customizer--will-animate');
        el.classList.add('customizer--animate-in');
      }, delay || 0);
      obs.disconnect();
    });
  }, { threshold: 0.3 });
  observer.observe(el);
}

/* ── Init ───────────────────────────────────────────────── */

function init() {
  var hasZeptoBtn = !!document.querySelector('button.pplr-c-button');

  document.querySelectorAll('[data-charm-customizer]').forEach((el) => {
    if (!el._charmCustomizer) {
      el._charmCustomizer = new CharmCustomizer(el);
    }
    if (!el._animationAttached) {
      el._animationAttached = true;
      attachCustomizerAnimation(el, hasZeptoBtn ? 80 : 0);
    }
  });

  document.querySelectorAll('[data-leather-customizer]').forEach((el) => {
    if (!el._leatherCustomizer) {
      el._leatherCustomizer = new LeatherCustomizer(el);
    }
    // Only animate if visible on load — if hidden (variant has no leather config),
    // skip so the element doesn't remain invisible when a new variant makes it visible.
    if (!el._animationAttached && !el.hidden) {
      el._animationAttached = true;
      attachCustomizerAnimation(el, hasZeptoBtn ? 80 : 0);
    }
  });

  cleanupCharmOrphans();
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', init);
} else {
  init();
}

document.documentElement.addEventListener('cart:change', () => {
  cleanupCharmOrphans();
});
